<script>
	import PageSection from "../../components/PageSection.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";

	import { registerFormStart } from "../../tealium";

	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let lastVisitedPage = null;
	export let persistUrl = null;
	export let title = null;

	pageNumber.update((p) => pageIndex);
	$model.LastPageVisited = lastVisitedPage;
	document.title = pageTitle;

	//  Get the user Agent
	$model.UserAgent = navigator.userAgent;
	$model.referrer = document.referrer;
	$model.RegistrationSegmentId = null;
</script>

<PageSection>
	<div class="row justify-content-center">
		<div class="col-md-8 col-sm-12">
			<h1 class="text-center">{projectSettings.classActionName}</h1>
			<h2 class="text-center">CLAIMANT REGISTRATION FORM</h2>
		</div>
	</div>

	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12">
			<p>
				<b>Sites under continued investigation</b>
			</p>
			<p>
				Shine Lawyers’ Class Action team are continuing to investigate potential class actions for the remaining
				communities where the Department of Defence has undertaken environmental monitoring of potential PFAS
				chemical contamination.
			</p>
			<p>
				If your property is located within one of the contamination investigation areas listed below, you are
				encouraged to register your interest and our team will contact you when we have further information.
			</p>
			<p>
				<b>New South Wales</b>
			</p>
			<ul>
				<li>Blamey Barracks (Kapooka)</li>
				<li>HMAS Albatross</li>
				<li>Holsworthy Barracks</li>
				<li>Singleton Military Area</li>
			</ul>
			<p>
				<b>Northern Territory</b>
			</p>
			<ul>
				<li>Robertson Barracks</li>
			</ul>
			<p>
				<b>Queensland</b>
			</p>
			<ul>
				<li>HMAS Cairns</li>
				<li>Lavarack Barracks</li>
				<li>RAAF Base Amberley</li>
				<li>Wide Bay Training Area</li>
			</ul>
			<p>
				<b>Victoria</b>
			</p>
			<ul>
				<li>HMAS Cerberus</li>
				<li>RAAF Base East Sale</li>
				<li>RAAF Williams Laverton Base</li>
			</ul>
			<p>
				<b>Western Australia</b>
			</p>
			<ul>
				<li>Gingin Satellite Airfield</li>
				<li>HMAS Stirling</li>
				<li>Naval Communication Station Harold E Holt A & B</li>
				<li>RAAF Base Learmonth</li>
				<li>Jandakot Airport</li>
			</ul>
		</div>
	</div>
	<div class="row justify-content-md-center register-btn">
		<div class="col-md-8 col-sm-12 text-center">
			<NavigationButtons
				{persistUrl}
				showPrevious="false"
				{nextPage}
				nextPageLabel="REGISTER YOUR INTEREST"
				verifyCaptcha="true"
				pageName={title}
				tealiumTag={false}
				onNext={() => registerFormStart()}
			></NavigationButtons>
		</div>
	</div>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12">
			<p>
				If you are in any doubt about whether you need to complete this form, or whether you have suffered
				damages, please contact Shine Lawyers on
				<ClassActionPhoneNumber></ClassActionPhoneNumber> or via email to
				<ClassActionEmailAddress></ClassActionEmailAddress>.
			</p>
		</div>
	</div>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	h2 {
		font-size: 1.1em;
		margin-bottom: 16px;
		font-weight: 700;
	}

	a {
		text-decoration: none;
	}

	a:hover {
		text-decoration: underline;
	}

	.register-btn {
		margin-bottom: 20px;
	}
</style>
